import axios from 'axios'
import qs from 'qs'
import router from '../router'
import store from '../store'
import { Message, Loading } from 'element-ui'
import {signatureGenerate} from '@/utils/index'
import { setCookie } from './common'
// import Vue from 'vue'

// const vue = new Vue()

// 请求次数
let retry = 1
/* 添加响应拦截器 */
axios.interceptors.response.use(function (response) {
  /* 对响应数据做些事 */
  return response
}, function (error) {
  /* 请求错误时做些事 */
  // 请求超时的之后，抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    var config = error.config
    config.__retryCount = config.__retryCount || 0

    if (config.__retryCount >= retry) {
      console.log(config.__retryCount, 'config.__retryCount')
      // Reject with the error
      //   vue.$message({
      //       showClose: true,
      //       message: '请求超时',
      //       type: 'error'
      //   })
      console.log('请求超时')
        .then(() => {
          window.location.reload()
        })
        .catch(() => {
          confirm.close()
        })

      return Promise.reject(error)
    }

    // Increase the retry count
    config.__retryCount += 1

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        resolve()
      }, config.retryDelay || 1)
    })

    return backoff.then(function () {
      return axios(config)
    })
  } else {
    return Promise.reject(error)
  }
})

export default {
  fetch(path, params, contentType) {
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) {
        params[key] = "";
      }
    });
    let dey = signatureGenerate(params)
    // let network = true
    // window.addEventListener('offline', () => {
    //   network = false
    // })
    // window.addEventListener('online', () => {
    //   network = true
    // })
    // if(!network) {
    //   console.log('网络不良');
    //   Message({
    //     message: '当前网络不佳,请检查网络信息',
    //     type: 'warning'
    //   })
    //   return
    // }
    // if(network) {
    //   console.log('网络良好');
    // }

    let loadingInstance =Loading.service({
      text:'加载中',
      background: 'rgba(255,255,255,0.1)'
    });
    params.token = store.state.user.token;
    params.sign = dey.sign;
    params.timestamp = dey.timestamp;
   
    if (!(params instanceof FormData)) {
      if (!contentType) {
        contentType = 'application/x-www-form-urlencoded'
        params = qs.stringify({
          ...params
        })
      }
    }
    return axios.post(path, params, {
      headers: {
        'Content-Type': contentType,
      }
    }).then(function (req) {
      let data = req.data
      if (data.status == 200) {
        loadingInstance.close()
      }
      if (data.status && data.status !== 200) {
        loadingInstance.close()
        //判断token是否过期
        if (data.status == -1) {
          //清除旧的token
          localStorage.clear()//清除本地缓存
          router.app.$options.store.commit('CLEARDATA')
          document.cookie = `${"province"}=; Max-Age=0; path=/;`;
          document.cookie = `${"province_id"}=; Max-Age=0; path=/;`;
          setCookie("isTourist", 1, 7);
          Message({
            message: data.msg+'，即将为您跳转至登录页',
            type: 'info'
          })
          setTimeout(() => {
            location.reload()
          }, 1500);
        }
        if (data.status == -4) {
          Message({
            message: '接口签名失败',
            type: 'info'
          })
        }
        console.log(data.message)
        return Promise.reject(data)
      }
      return data
    }).catch((err) => {
      // Message({
      //   message: err.msg,
      //   type: 'err'
      // })
      return err
    })
  }
}
